/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import MyTrainingPresenter from "./ViewDigitalDocsPresenter";
import DTOMytraining from "./DTOViewDigitalDocs";
import { useTranslation } from "react-i18next";
import DTOViewDigitalDocs from "./DTOViewDigitalDocs";
import ViewDigitalDocsPresenter from "./ViewDigitalDocsPresenter";

const ViewDigitalDocsController = (props: any) => {
  const { t, i18n } = useTranslation();
  const [myViewLogsData, setMyViewLogsData] = useState([]);
  const [id, setId] = useState();

  function callBackFunc(data: any) {
    setMyViewLogsData(data);
  }
  useEffect(()=>{
    if (props?.id) {
      setId(props?.id)
    }
  }, [props?.id])
  return (
    <>
      <DTOViewDigitalDocs
        setViewLogsData={callBackFunc}
        id={id}
      />
      <ViewDigitalDocsPresenter
        myViewLogsData={myViewLogsData}
        trans={t}
        i18n={i18n}
        setCloseModal={props?.onClose}
      />
    </>
  );
};
export default ViewDigitalDocsController;
